<template>
  <page :toolbar="toolbar">
    <template v-slot:content>
      <v-container>
        <v-row row wrap>
          <v-col cols="12" v-for="company in companies" :key="company._id">
            <v-card class="pa-3" @click="viewCompany(company)">
              <div v-bind:class="!mobile ? 'mobileCard' : ''">
                <h1>{{ company.name }}</h1>
                <h2>{{ moment(company.createdAt).format('LLLL') }}</h2>
              </div>
              <h3>{{ company._id }}</h3>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment, { min } from 'moment';

export default {
  data() {
    return {
      title: ''
    };
  },
  computed: {
    ...mapState({
      account: state => state.account,
      admin: state => state.admin
    }),
    loading() {
      return this.admin.loading;
    },
    companies() {
      return this.admin.companies;
    },
    mobile() {
      return this.$vuetify.breakpoint.xs;
    },
    toolbar() {
      return {
        title: 'Companies'
      };
    }
  },
  methods: {
    ...mapActions('admin', ['fetchCompanies']),
    viewCompany(company) {
      this.$router.push('/admin/' + company._id);
    }
  },
  mounted() {
    this.fetchCompanies();
  }
};
</script>

<style>
.mobileCard {
  display: flex;
  justify-content: space-between;
}
</style>
